// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"249":"ps-confirmation","441":"monnify","494":"Register","572":"remita_mandate","794":"fw-confirmation","861":"Pay"}[chunkId] || chunkId) + "." + {"249":"ecd1d419","441":"71f2312f","494":"2e9ad18b","572":"21ae2a03","794":"0ae537f5","812":"1e9a5e0f","861":"65b7268b"}[chunkId] + ".css";
};